export default __webpack_public_path__ + "static/media/032-cherry.2d6ad710.svg";